import { ca } from '@cian/analytics';
import { TListingCompilationType } from '../../../types/promosPage';

export const trackListingCompilationClick = (type: TListingCompilationType) => {
  let analyticsType: string;

  switch (type) {
    case 'currentYearCompletion':
      analyticsType = 'almost_complete';
      break;
    case 'fineDecoration':
      analyticsType = 'decoration_finish';
      break;
    case 'maxDiscount':
      analyticsType = 'max_discount';
      break;
  }

  ca('eventSite', {
    action: 'click_sopr',
    category: 'BlackFriday',
    name: 'oldevent',
    label: 'co_promos',
    page: {
      extra: {
        type: analyticsType,
      },
    },
  });
};
